import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { sprayService } from '@iso/services';
import { useSelector } from 'react-redux';
import { TemplateModalWrapper } from './TemplateModals.styles';

const { TextArea } = Input;

const TemplateNameModal = ({ visible, onCancel, onSave, sprayJobData, permissionTaskData }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const propertyId = useSelector(state => state.property.activePropertyId);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      // Combine spray job data with permission/task data
      const combinedData = {
        ...sprayJobData,
        ...(permissionTaskData && {
          ppe_requirements: permissionTaskData.ppeRequirements,
          tasks: permissionTaskData.tasks
        })
      };

      // Remove save_as_template from the spray job data
      delete combinedData.save_as_template;

      const templateData = {
        spray_job_data: combinedData,
        property_id: propertyId,
        template_name: values.name,
        template_description: values.description
      };

      const response = await sprayService.createTemplate(templateData);

      if (response && response.code === '0000') {
        message.success('Template saved successfully');
        onSave();
        form.resetFields();
      } else {
        // Backend may return `message` as a string OR as an
        // ActiveRecord errors map (keyed by attribute → array of strings).
        // Flatten so the operator sees the real reason instead of the
        // generic "Failed to save template" that was masking validation
        // failures (template name uniqueness, missing chemical_id, etc).
        const errMsg = response?.message;
        const flat = typeof errMsg === 'string'
          ? errMsg
          : Object.values(errMsg || {}).flat().join(' • ');
        message.error(flat || 'Failed to save template');
      }
    } catch (error) {
      console.error('Error saving template:', error);
      const backendMsg = error?.response?.data?.message;
      const flat = typeof backendMsg === 'string'
        ? backendMsg
        : Object.values(backendMsg || {}).flat().join(' • ');
      message.error(flat || 'Failed to save template');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <TemplateModalWrapper
      title="Template name"
      open={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel} className="cancel-button">
          Cancel
        </Button>,
        <Button key="save" type="primary" loading={loading} onClick={handleSave} className="btn-success">
          Save
        </Button>
      ]}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Template name is required' }]}
        >
          <Input placeholder="Ex: Template N°1" />
        </Form.Item>
        
        <Form.Item
          name="description"
          label="Description"
        >
          <TextArea 
            placeholder="Enter description (optional)"
            rows={4}
          />
        </Form.Item>
      </Form>
    </TemplateModalWrapper>
  );
};

export default TemplateNameModal;